module.exports = __webpack_public_path__ + "img/graphql-logo.cb8bcb04.svg";